export default __webpack_public_path__ + "static/mann-vaskemaskin-35d614250c9459f039caff1faa89d8ae.png";